import cache from "../../utils/cache";
import apis from "../../request/apis";

export default {
    namespaced: true,
    state: {
        type: cache.getSession("casetype") || [], //案例类型
    },

    mutations: {
        changeCaseType(state, payload) {
            state.type = payload;
            cache.setSession("casetype", state.userinfo);
        }
    },

    actions: {
        getCaseType(store, params) {
            return new Promise((resolve, reject) => {
                apis.cases.getCaseTypeList({
                    datacenter_uuid: store.rootState.common.datacenteruuid
                }).then(res => {
                    store.commit("changeCaseType", res.data.list);
                    resolve(res.data.list);
                }).catch(reject);
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/case.js